module.exports = __webpack_public_path__ + "img/srcmOne.60a8a2da.png";